export default __webpack_public_path__ + "static/media/location_img.1012aa1f.webp";